module.exports = __webpack_public_path__ + "static/img/a038.ea60e0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a038.jpg
// module id = gOLX
// module chunks = 0